<template>
  <div>
    <oct-globalnav
      :user="user"
      @signout="onSignout"
    />

    <oct-user-form
      :token="token"
      :artworks="artworks"
      :exhibitions="exhibitions"
      :artfairs="artfairs"
      :news="news"
      v-bind.sync="user"
      v-if="initialized"
      @submit="submit"
    />

    <oct-dot-progress
      v-if="!initialized"
    />

    <oct-globalfooter
      :user="user"
      @signout="onSignout"
      @quit="onQuit"
    />

    <oct-svg />
  </div>
</template>

<script>
import OctAuth from '@/components/auth/OctAuth.js'
import {createProps} from '@/components/user/OctUser.js'
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import OctUserForm from '@/components/user-form/OctUserForm.vue'
import OctPrototypeView from '@/views/OctPrototypeView.js'
import OctSvg from '@/components/svg/OctSvg.vue'
import '@/assets/app.scss'

export default {
  mixins: [OctAuth, OctPrototypeView],
  name: 'OctDashboard',
  components: {
    OctUserForm,
    OctSvg
  },
  data () {
    return Object.assign({
      artworks: [],
      exhibitions: [],
      /** Art fairs */
      artfairs: [],
      /** Artworks releted to art fairs */
      artfairArtworks: [],
      news: [],
    }, createProps())
  },
  methods: {
    /** Initialization */
    async initialize () {
      // Redirect common user
      if (this.user.type !== 'artist' && this.user.type !== 'gallery') {
        location.href = '/account/settings'
        return
      }

      try {
        // Get user's atrworks
        let response = await OctApiAdaptor.getArtworks({
          [this.user.type]: this.user.id,
          counts: this.user.type === 'gallery' ? 12 : 11
        }, this.token)

        // Update user's artworks
        this.artworks = this.artworks.concat(response.items)

        // Get user's exhibitions
        response = await OctApiAdaptor.getExhibitions({
          [this.user.type]: this.user.id,
          // Exclude art fairs
          type: ['physical', 'digital'],
          counts: 3
        }, this.token)

        // update user's exhibitions
        this.exhibitions = this.exhibitions.concat(response.items)

        // Load art fairs if the user is a gallery
        if (this.user.type === 'gallery') {
          // Get all user's artfairs
          response = await OctApiAdaptor.getAllExhibitions({
            [this.user.type]: this.user.id,
            // Include only art fairs
            type: ['artfair'],
            counts: 100
          }, this.token)

          // Fetch all artworks from the art fairs
          let promises = []
          response.items.forEach(item => (
            promises.push(OctApiAdaptor.getArtworks({
              exhibition: item.id,
              counts: 500
            }, this.token)
              .then(response => response.items))
          ));

          // Artworks related to me
          // Some artworks contains the gallery in the extra gallery data
          const artfairArtworks = Object.values((await Promise.all(promises)).flat()
            .reduce((acc, cur) => {
              // Extra galleries property is exist
              // Extra galleries contains the gallery
              if (cur.data && cur.data.extraGalleries &&
                    cur.data.extraGalleries.some(a => a.id === this.user.id))
                acc[cur.id] = cur
              return acc
            }, {}))

          // Merge art fair artworks into artworks and re order
          this.artworks = (await OctApiAdaptor.getArtworks({
            ids: artfairArtworks.map(item => item.id).concat(this.artworks.map(item => item.id))
          }, this.token)).items.slice(0, 12)

          // Update user's artfairs
          this.artfairs = this.artfairs.concat(response.items.filter(item => (
            // Narrow down to the art fair created by the user
            item.gallery.id === this.user.id
          )))
            // Narrow down to 3 items
            .slice(0, 3) 
        }

        // Get user's news
        let page = 1
        while (this.news.length < 3) {
          response = await OctApiAdaptor.getNews({
            [this.user.type]: this.user.id,
            counts: 10,
            page: page++
          }, this.token)

          // Update user's news
          // Exclude art fair related items if the user is not an art fair account
          this.news = this.news.concat(
            this.user.artfair ? response.items :
            response.items.filter(item => !item.data.isArtFair)
          )

          // No more news
          if (!response.items.length) break;
        }

        // Narrow down to 3
        this.news = this.news.splice(0, 3)

        this.initialized = true
      } catch (thrown) {
        alert('情報を正しく取得できませんでした')
        console.error(thrown)
      }
    },
    /** Form submit handler */
    async submit () {
      try {
        // Update the user
        await OctApiAdaptor.updateUser(this.user, this.token)
        this.$set(this, 'user', await OctApiAdaptor.getUser(null, this.token))
      } catch (thrown) {
        alert('システムエラーが発生しました')
        console.log(thrown)
      }
    },
  }
}
</script>